/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
    PersonHandleToJSONTyped,
} from './PersonHandle';
import type { RecoverableFactor } from './RecoverableFactor';
import {
    RecoverableFactorFromJSON,
    RecoverableFactorFromJSONTyped,
    RecoverableFactorToJSON,
    RecoverableFactorToJSONTyped,
} from './RecoverableFactor';

/**
 * 
 * @export
 * @interface RecoverRequest
 */
export interface RecoverRequest {
    /**
     * 
     * @type {PersonHandle}
     * @memberof RecoverRequest
     */
    handle: PersonHandle;
    /**
     * 
     * @type {RecoverableFactor}
     * @memberof RecoverRequest
     */
    factor: RecoverableFactor;
}

/**
 * Check if a given object implements the RecoverRequest interface.
 */
export function instanceOfRecoverRequest(value: object): value is RecoverRequest {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('factor' in value) || value['factor'] === undefined) return false;
    return true;
}

export function RecoverRequestFromJSON(json: any): RecoverRequest {
    return RecoverRequestFromJSONTyped(json, false);
}

export function RecoverRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecoverRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': PersonHandleFromJSON(json['handle']),
        'factor': RecoverableFactorFromJSON(json['factor']),
    };
}

export function RecoverRequestToJSON(json: any): RecoverRequest {
    return RecoverRequestToJSONTyped(json, false);
}

export function RecoverRequestToJSONTyped(value?: RecoverRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': PersonHandleToJSON(value['handle']),
        'factor': RecoverableFactorToJSON(value['factor']),
    };
}

